import React from 'react';
import ChevronDownSmall from 'wix-ui-icons-common/ChevronDownSmall';
import classnames from 'classnames';
import { LOGGER_TYPES } from '../../../../LoggerFactory/loggerTypes';
import { wixDocsObjectShowMembersClick } from '../../../../LoggerFactory/BiAnalyticsLogger/events';
import {
  getArticleNameFromPathname,
  getCategoryNameFromPathname,
} from '../../../../LoggerFactory/BiAnalyticsLogger/events/utils';
import { TOGGLE_EXAMPLES_ACTIONS } from '../../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { LoggerContext } from '../../../../appContext/LoggerProvider';
import { StoreContext } from '../../../../appContext/StoreProvider';
import style from './showMembersButton.scss';
import { TextButton } from 'wix-style-react';

export const ShowMembersButton = ({ onClick, text, showMembers }) => {
  const { store } = React.useContext(StoreContext);
  const { logger } = React.useContext(LoggerContext);
  const onShowMembersButtonClicked = () => {
    onClick();
    logger
      .getLogger(LOGGER_TYPES.ANALYTICS_BI)
      .log(wixDocsObjectShowMembersClick, {
        article_name: getArticleNameFromPathname(
          window?.location.pathname,
          store,
        ),
        article_url: window.location.href,
        category_name: getCategoryNameFromPathname(
          window?.location.pathname,
          store,
        ),
        action: showMembers
          ? TOGGLE_EXAMPLES_ACTIONS.CLOSE
          : TOGGLE_EXAMPLES_ACTIONS.OPEN,
      });
  };

  return (
    <TextButton
      as="button"
      size="small"
      suffixIcon={
        <ChevronDownSmall
          className={classnames({ [style.expanded]: showMembers })}
        />
      }
      weight="normal"
      onClick={onShowMembersButtonClicked}
      className={style.button}
      dataHook="action-button"
    >
      {text}
    </TextButton>
  );
};
